import { GlobalMessageType } from '@spartacus/core';
import { faExclamationCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';

export const CATEGORY = '/catalogs/categories/1';
export const VALIDATE_EMAIL = '/forgotten-username-password/validate-email';
export const VALIDATE_PASSWORD_ANSWER =
  '/forgotten-username-password/validate-password-answer';
export const RESET_PASSWORD = '/forgotten-username-password/reset-password';
export const USER_NAME = '/users/current';
export const USER_ACCOUNT = '/users/';
export const ADD_CARD = '/users/current/paymentdetails';
export const GET_INVOICES = '/my-account/invoices';
export const GET_MAKE_PAYMENT = '/my-account/makepayment';
export const DOWNLOAD_INVOICE_CREDIT_PDF = 'my-account/invoicepdf';
export const GET_CARD_DETAILS = '/my-account/payment-info';
export const POST_CARD_DETAILS = '/my-account/creditReview';
export const SUBMIT_CREDIT = '/my-account/payment-confirmation-credit';
export const GET_PROVINCES = '/countries/CA/regions';
export const GET_PRACTICEORFACILITYTYPE = '/enumeration';
export const POST_ACCOUNT_REGISTRATION_DETAILS = '/account/register';
export const SEND_RESET_PASSWORD_EMAIL = '/customer-register/reset-password';

export const VALIDATE_ACCOUNT_INFORMATION_USER_REGISTRATION =
  '/customer-register/account-information';

export const VALIDATE_INDIRECT_ACCOUNT_INFORMATION_USER_REGISTRATION =
  '/customer-register/indirect-account-information';

export const VALIDATE_INDIRECT_ACCOUNT_INFORMATION_IN_AKAMAI =
  '/customer-register/indirect-account-information-validation';

export const POST_USER_REGISTRATION_INFO =
  '/customer-register/customer-information';
export const POST_LOGGEDIN_USER_REGISTRATION_INFO =
  '/customer-register/same-account-customer-information';

export const GET_CARD = '/my-account/payment-info?';

export const GET_OPEN_STATEMENTS = '/my-account/statements';
export const GET_ALL_STATEMENTS_DATA_RANGE = '/my-account/statementsDisplay';

export const GET_SEARCH_HISTORY = '/users/';

export const GET_ACCOUNT_ID = '/users/current/b2bUnits';

export const SUBMIT_CREDIT_CARD_PAYMENT = '/my-account/ccinvoice-payment';
export const GET_ORDER_HISTORY = '/users/';
export const CATALOGS = '/catalogs/';
export const CATALOGSTYPE = '/materialProduct/get-material/';
export const FAQ = '/frequently-asked-questions';
export const HELP_CENTER = '/help-center/search';
export const GET_PAYMENTMODES = '/paymentmodes/eligible';

export enum FITUSIRAN_FLAGS {
  FITUSIRAN_UNIT_SELECTED = 'fitusiransUnitSelected',
  FITUSIRAN_ITEM_REMOVED = 'fitusiransProdutsRemoved'
}

export enum WAYRILZ_FLAGS {
  WAYRILZ_UNIT_SELECTED = 'wayrilzUnitSelected',
  WAYRILZ_ITEM_REMOVED = 'wayrilzProdutsRemoved'
}


export const FITUSIRAN_TRANS_KEYS = new Map<FITUSIRAN_FLAGS, any>([
  [FITUSIRAN_FLAGS.FITUSIRAN_UNIT_SELECTED, {
    transKey: 'account.newProductsAvailable',
    messageType: GlobalMessageType.MSG_TYPE_INFO
  }],
  [FITUSIRAN_FLAGS.FITUSIRAN_ITEM_REMOVED, {
    transKey: 'account.fitusiranItemRemoved',
    messageType: GlobalMessageType.MSG_TYPE_WARNING
  }]
]);

export const WAYRILZ_TRANS_KEYS = new Map<WAYRILZ_FLAGS, any>([
  [WAYRILZ_FLAGS.WAYRILZ_UNIT_SELECTED, {
    transKey: 'account.newProductsAvailable',
    messageType: GlobalMessageType.MSG_TYPE_INFO
  }],
  [WAYRILZ_FLAGS.WAYRILZ_ITEM_REMOVED, {
    transKey: 'account.wayrilzItemRemoved',
    messageType: GlobalMessageType.MSG_TYPE_WARNING
  }]
]);


export enum PaymentsMods {
  BILL_ME_LATER = 'BILL_ME_LATER',
  CREDIT_CARD = 'CREDIT_CARD',
  ECHECK = 'ECHECK',
}

export const PAYMENT_MODS_FOR_MAKE_A_PAYMENT = [PaymentsMods.ECHECK]; //TODO this need to be taken from the endpoint in the future

export enum AccountOverviewTabs {
  INVOICES = 'Invoices',
  CREDITS = 'Credits',
  ORDERS = 'Orders',
  STATEMENTS = 'Statements'
}

export enum OTP_METHODS {
  EMAIL = 'e-mail',
  MOBILE = 'mobile'
}

export enum PreferencesTabs {
  USER = 'User',
  ACCOUNT = 'Account',
  PAYMENT = 'Payment',
}

export enum StockAvailableStatus {
  NORMAL = 'NORMAL',
  LIMITED = 'LIMITED',
  ENDED = 'ENDED',
  LOW = 'LOW',
}

export enum OrderCappingStatus {
  QUANTITY_LIMIT = 'quantityLimit',
}

export const ORDER_CAPPING_ICONS = new Map<OrderCappingStatus, IconDefinition>([
  [OrderCappingStatus.QUANTITY_LIMIT, faExclamationCircle]
]);

export enum ReportsPageTabs {
  REPORTS = 'reports',
  STATEMENTS = 'statements',
}

export enum SalesOrg {
  US03 = 'US03',
  US12 = 'US12',
  US12US03 = 'US12US03',
  US03US12 = 'US03US12',
}

export const US_DATE_FORMAT = 'MM/DD/YYYY';
export const EU_DATE_FORMAT = 'DD/MM/YYYY';
